export default __webpack_public_path__ + "static/w-2-mobile-94860c521744479888db4869feaabba4.webp";